import { Location } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { ToastService, getDateAsUTC } from 'src/app/core';
import {
  AppUser,
  EmailApi,
  EmployeeProfile,
  EmployeeProfileApi,
  EmployeeProfileCandidate,
  EmployeeProfileEditComment,
  ImmigrationCommentTypes,
  LookupApi,
  LookupField
} from 'src/app/core/api.gen';
import { AuthService } from 'src/app/core/auth.service';
import { DialogService } from 'src/app/core/dialog.service';
import { LoaderService } from 'src/app/core/loader.service';
import { MethodValidityService } from 'src/app/immigration/services/validations/method-validity.service';
import { ArCommentComponent } from 'src/app/shared/ar-comment/ar-comment.component';
import { getModifiedNameWithPhone } from 'src/app/shared/form/generic-utils';
import { EmployeeProfileCommentsComponent } from 'src/app/shared/immigration-comments/employee-profile-comments.component';
import { nullSafe } from 'src/app/utils';
import { UserProfileStepService } from '../../services/user-profile-steps.service';
import { CommonService } from '../../../../../src/app/core/common.service';
import { ErrorTypes } from 'src/app/shared/module-types';
import { CountryTypesValues } from 'src/app/immigration/services/visatypes/country-types.enum';

@Component({
  selector: 'eos-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css'],
})
export class UserProfileComponent implements OnInit, OnChanges {

  @Input() employeeId = 0;
  @Input() showDefaultHeader = true;
  @Input() onAppRej: () => void;
  @Input() model: EmployeeProfile;

  @Input() isSearch = false;
  @Input() isEdit = false;
  isFromPB = false;
  encodedGpn;
  encodedGui;
  country: string;
  immUserProfileView: boolean;
  // profileId = 0;
  showAppRej = false;
  showActive = false;
  profileConfirmed = false;
  activeTabIdx: number;
  
  user: AppUser;
  userFields: any;
  formArray: UntypedFormArray;
  uploadedFiles: any[] = [];
  validDocuments = [];
  dependentDocs: number[] = [];
  masterData :any;
  expiryDatesUpdatedSubscription:any;
  isUserProfileExpiryDatesUpdated:boolean;
  constructor(
    private authService: AuthService,
    private userStepService: UserProfileStepService,
    private employeeApi: EmployeeProfileApi,
    private activeRoute: ActivatedRoute,
    private loader: LoaderService,
    private toaster: ToastService,
    public modal: NgbActiveModal,
    private dialog: NgbModal,
    private _location: Location,
    private toast: ToastService,
    private dialogServ: DialogService,
    private emailAPI: EmailApi,
    private validations: MethodValidityService,
    private common: CommonService,
    private lookup: LookupApi,
    private router: Router,
  ) {
    this.user = this.authService.ActiveUser;
    this.activeRoute.params.subscribe(routeParams => {
      this.country = routeParams.country;
      this.employeeId = routeParams.id ?
        routeParams.id : this.authService.ActiveUser.employeeId;
      this.encodedGpn = routeParams.gpn;
      this.encodedGui = routeParams.gui;
      this.immUserProfileView = routeParams.immUserProfileView ? true : false;
    });
  }

  ngOnInit() {
    
    //checks if user profile expiry dates are updated
    this.expiryDatesUpdatedSubscription = this.common.isUserProfileExpiryDatesUpdated.subscribe(isUpdated => {
      if (isUpdated !== null) {
        this.isUserProfileExpiryDatesUpdated = isUpdated;
      }
      else{
        this.isUserProfileExpiryDatesUpdated = true;
      }
    });

    this.activeRoute.data.subscribe(rd => {
      this.showAppRej = rd.showAppRej;
      this.isSearch = rd.isSearch;
      this.isFromPB = rd.isFromPB || false;
    });
    this.activeTabIdx = 0;

    this.userStepService.empOfficeLocationCountry = () => this.empOfficeLocationCountry();
    this.userStepService.nationalityCurrentLocation = () => this.nationalityCurrentLocation();
    this.userStepService.empNationalityType = () => this.empNationalityType();
    this.userStepService.isGCCNationals = () => this.isGCCNationals();
    this.userStepService.isVisaApproverView = () => this.isVisaApproverView();
    this.userStepService.isVisaApprover = () => this.isVisaApprover();
    this.userFields = this.userStepService.getSteps(this.immUserProfileView);
    this.formArray = new UntypedFormArray(this.userFields.map(() => new UntypedFormGroup({})));

    this.fetchData();
    this.lookup.getDependentDocuments("EMP").subscribe(resp => {
      this.dependentDocs = resp;
    });
    
  }
  ngOnChanges() {
  }

  fetchData(){
    if (!this.isSearch) {
      this.loadData();
    } else {
      this.loadDataFromMaster();
    }
  }
  init() {
    this.model = new EmployeeProfile();
    this.model.nationality = new LookupField();
    this.model.passportType = new LookupField();
    this.model.onboardingType = new LookupField();
    this.model.profileStatus = new LookupField();
    this.model.employeeStatus = new LookupField();
    this.model.officeLocationCountry = new LookupField();
    this.model.employeeCategory = new LookupField();
    this.model.workPermitType = new LookupField();
    this.model.categoryOfJobOffer = new LookupField();
    this.model.gender = new LookupField();
  }

  loadData() {
    this.loader.show();
    this.employeeApi.getProfile(this.employeeId).pipe(finalize(() => {
      this.loader.clear();
      this.getMasterData();
    })).subscribe(resp => {
      if (resp) {
        this.model = resp;
        this.isEdit = !resp.isApproved;
      }
    });
  }

  loadDataFromMaster() {
    this.loader.show();
    const decodedGui = decodeURIComponent(this.encodedGui);
    this.country = (this.country != null && this.country != undefined) ? this.country : ((this.immUserProfileView || this.isFromPB) ? "NA" : "All");
    if (this.encodedGpn == "null") {
      this.employeeApi.getEmployeeProfileDetailsByGUI(decodedGui)
        .pipe(finalize(() => {
          this.loader.clear();
        })).subscribe(resp => {
          this.model = resp;
          this.isEdit = !resp.isApproved;
          this.showActive = resp.isActive;
          this.masterData = { ...resp };
          if (this.isSearch && !this.showActive) {
            this.formArray.disable();
          }
        });
    }
    else {
      const decodedGpn = decodeURIComponent(this.encodedGpn);
      this.employeeApi.getEmployeeProfilesDetails(decodedGpn, decodedGui, this.country)
        .pipe(finalize(() => {
          this.loader.clear();
        })).subscribe(resp => {
          this.model = resp;
          this.isEdit = !resp.isApproved;
          this.showActive = resp.isActive;
          this.masterData = {...resp};
          if (this.isSearch && !this.showActive) {
            this.formArray.disable();
          }
        });
    }
  }

  empOfficeLocationCountry(): number {
    return nullSafe(() => this.model.officeLocationCountry.id, 0);
  }
  empNationalityType(): number {
    return nullSafe(() => this.model.nationalityTypeId.id, 0);
  }
  nationalityCurrentLocation(): number {
    return nullSafe(() => this.model.nationality.id, 0);
  }
  isGCCNationals(): boolean {
    return nullSafe(() => [26, 127, 175, 188, 203, 241].includes(this.model.nationality.id), false);
  }

  isVisaApproverView() : boolean {   
    return (this.isSearch && this.country != null && this.country != undefined && this.country !='All' && this.country != 'NA') ? true :false;     
  }

  isVisaApprover() : boolean {   
    return this.authService.ActiveUser.features.includes('VisaApprover');
 }
 isRewardsTeam() : boolean {   
   return this.authService.ActiveUser.activeRole == 'RewardsTeam';
}
  get noProfile() {
    return this.model && this.model.id <= 0;
  }

  get fileUploadReadonly() {
    return (this.model && this.model.id <= 0) || (!this.showActive && this.isSearch) || (this.isRewardsTeam() && this.isSearch|| this.isFromPB)
  }

  get tabOfDocumentUpload() {
    return 1; // change this return, do not change the template
  }
  get showingFileUpload() {
    return this.activeTabIdx === this.tabOfDocumentUpload; // active tab index where the doc upload window will be showing
  }

  get ActOrInact() {
    if (this.showActive) {
      return 'This employee is currently active';
    }

    return 'This employee is currently inactive';
  }
  get canUploadDocuments(): boolean {
    return !(this.model && this.model.id <= 0);
  }

save() {
  this.loader.show();
  this.employeeApi.save(this.model)
      .pipe(finalize(() => {
        this.loader.clear();
      }))
    .subscribe(resp => {
      this.model = resp.data;
      this.formArray.markAsPristine();
        this.toaster.success('Profile saved successfully!');
      });
}

    saveContinue(isTabMove: boolean) {
    if (this.isSearch) {
        this.saveProfile(isTabMove);
    } else {
        if (!this.validations.validateSubmit(this.formArray)) {
            this.activeTabIdx = 0;
            return;
        }
        this.loader.show();
        const candidate = this.getUserCandidate();
        this.employeeApi.submit(false, candidate).pipe(finalize(() => {
            this.loader.clear();
        })).subscribe(resp => {
            this.model = resp.data;
            this.isEdit = !resp.data.isApproved;
            this.formArray.markAsPristine();
            this.dialogServ.showPopUpMessage('Profile saved as draft', () => {
                this.toaster.success('Profile saved successfully!');
                this.loadData();
                this.next(isTabMove);
      });
        });
    }
}

  saveProfile(isTabMove: boolean) {
    if (!this.validations.validateSubmit(this.formArray)) {
      this.activeTabIdx = 0;
      return;
    }
    this.confirmExpiryUpdate(
      ()=>{
        // on expiry date confirm
        this.loader.show();
        this.model.labourCardExpiryDate = getDateAsUTC(this.model.labourCardExpiryDate);
        this.model.employeeVisaExpiryDate = getDateAsUTC(this.model.employeeVisaExpiryDate);
        this.model.missionVisaExpiryDate = getDateAsUTC(this.model.missionVisaExpiryDate);
        this.model.workPermitExpiryDate = getDateAsUTC(this.model.workPermitExpiryDate);
        this.model.passportExpiryDate = getDateAsUTC(this.model.passportExpiryDate);
        this.model.iqamaExpiryDate = getDateAsUTC(this.model.iqamaExpiryDate);
        this.model.dateOfExit = getDateAsUTC(this.model.dateOfExit);
        this.model.lastWorkingDay = getDateAsUTC(this.model.lastWorkingDay);
        this.model.dateOfBirth = getDateAsUTC(this.model.dateOfBirth);       
        this.model.rpExpiryDate = getDateAsUTC(this.model.rpExpiryDate);

        this.employeeApi.updateEmployeeProfile(this.country, false, this.model)
          .pipe(finalize(() => {
            this.loader.clear();
          }))
          .subscribe(resp => {
            this.model = resp.data;
            this.masterData = {...resp.data};
            this.formArray.markAsPristine();
            this.toaster.success('Profile updated successfully!');
            this.next(isTabMove);
          });
      },
      ()=>{
        // on expiry date confirmation cancelled
        return;
      }
    )
  }

    submit() {
    const candidate = this.getUserCandidate();
     
    if (!this.validateEmployeeProfile(candidate)) {
        return;
      }

    if(!this.isSearch){
      this.confirmExpiryUpdate(
        () => {
           // on expiry date confirm
          this.loader.show();

          this.employeeApi.submit(true, candidate).pipe(finalize(() => {
            this.loader.clear();
          })).subscribe(resp => {
            this.model = resp.data;
            this.isEdit = !resp.data.isApproved;
            this.formArray.markAsPristine();
            this.toaster.success('Profile submitted successfully!');
            if (resp.errorCode == ErrorTypes.EMAIL_Exception) {
              this.toaster.warning('Email not send!');
            }
            else if (resp.errorCode == ErrorTypes.AUTO_APPROVAL_FAILED) {
              this.toaster.warning('Auto approval failed !');
            }
             
            this.loadData();
            this.profileConfirmed = false;
            //setTimeout(() => { this.router.navigate(['/home']); }, 3000)
            // To show the Pop up for creating a new request in Transfer of residency to new passport visa tiles
            const showVisaPopup = !this.isVisaApproverView() 
                                 && this.isPassportExpiryChanged()
                                 && [CountryTypesValues.BHR, CountryTypesValues.OMAN, CountryTypesValues.QAT, CountryTypesValues.KWT, CountryTypesValues.SaudiArabia, CountryTypesValues.UAE].includes(this.model.officeLocationCountry.value as CountryTypesValues);
            if (showVisaPopup) {
              const countryCode = this.model.officeLocationCountry.value ? `${this.model.officeLocationCountry.value}` : '';
              this.showPassportTransferPopup(countryCode);
            } else {
              setTimeout(() => { this.router.navigate(['/home']); }, 3000);
            }
            //this.router.navigate(['/home']);
          });
        },
        () => {
          //on expiry date confirmation cancelled
          return;
        }
      );
    } 
  }

    submitProfile() {
    const candidate = this.getUserCandidate();
    if (!this.validateEmployeeProfile(candidate)) {
      return;
    }
    this.loader.show();
    this.model.labourCardExpiryDate = getDateAsUTC(this.model.labourCardExpiryDate);
    this.model.employeeVisaExpiryDate = getDateAsUTC(this.model.employeeVisaExpiryDate);
    this.model.missionVisaExpiryDate = getDateAsUTC(this.model.missionVisaExpiryDate);
    this.model.workPermitExpiryDate = getDateAsUTC(this.model.workPermitExpiryDate);
    this.model.passportExpiryDate = getDateAsUTC(this.model.passportExpiryDate);
    this.model.iqamaExpiryDate = getDateAsUTC(this.model.iqamaExpiryDate);
    this.model.dateOfExit = getDateAsUTC(this.model.dateOfExit);
    this.model.lastWorkingDay = getDateAsUTC(this.model.lastWorkingDay);
    this.model.dateOfBirth = getDateAsUTC(this.model.dateOfBirth);   
    this.model.rpExpiryDate = getDateAsUTC(this.model.rpExpiryDate);
    this.employeeApi.updateEmployeeProfile(this.country, true, this.model)
      .pipe(finalize(() => {
        this.loader.clear();
      }))
      .subscribe(resp => {
        this.model = resp.data;
        this.formArray.markAsPristine();
        this.toaster.success('Profile submitted successfully!');
        if (resp.errorCode == ErrorTypes.EMAIL_Exception) {
          this.toaster.warning('Email not send!');
        }
        setTimeout(() => { this.close(); }, 3000)
        //this.close();
      });
    this.profileConfirmed = false;
  }

  next(isTabMove: boolean) {
    if (isTabMove) {
      this.activeTabIdx = 1;
    }
  }

  openComments() {
    this.comments(null, true);
  }

  comments(type: ImmigrationCommentTypes, readonly?: boolean) {
    const comment = this.dialog.open(EmployeeProfileCommentsComponent);
    comment.componentInstance.readonly = readonly;
    comment.componentInstance.commentType = type;
    comment.componentInstance.profileId = this.model.id;
    comment.componentInstance.profileStatusId = this.model.profileStatus.id;
  }

  configureComment(commentFromBox, type) {
    const comment = new EmployeeProfileEditComment();
    comment.comment = commentFromBox.trim();
    comment.profileId = this.model.id;
    comment.statusId = this.model.profileStatus.id;
    comment.commentType = type;
    return comment;
  }

  getUserCandidate() {
    const model = new EmployeeProfileCandidate();
    model.init({
      profile: this.model,
      countryCode: this.country,
      immigrationComment: new EmployeeProfileEditComment()
    });

    const pathWithProp =
      ["profile.passportExpiryDate", "profile.dateOfBirth", "profile.labourCardExpiryDate",
        "profile.employeeVisaExpiryDate",
        "profile.missionVisaExpiryDate",
        "profile.workPermitExpiryDate",
        "profile.iqamaExpiryDate",
        "profile.dateOfExit",
        "profile.cprExpiryDate",
        "profile.rpExpiryDate",
        "profile.civilIdExpiryDate",
        "profile.pensionRegistrationDate",
        "profile.lastWorkingDay",

      ];

    this.common.updateDateProperty(model, pathWithProp);

    return model;
  }
  setValidDocuments(event) {
    this.validDocuments = event;
  }
  GetDocuments($event) {
    this.uploadedFiles = $event;
  }
  closeDelegateWarning() {
  }
  rejectProfile() {
    const candidate = this.getUserCandidate();
    this.getCommentBox((comment) => {
      this.loader.show();

      if (comment && comment.trim().length > 0) {
        candidate.profileEditComment =
          this.configureComment(comment, ImmigrationCommentTypes.Reject);
      }

      this.employeeApi.rejectEmployeeProfile(candidate).pipe(finalize(() => {
        this.loader.clear();
      })).subscribe(resp => {
        this.toaster.success("Rejected successfully!");
        this.close();
      });
    }, false, "");
  }

  approveProfile() {
    const candidate = this.getUserCandidate();
    if (!this.validations.validateSubmit(this.formArray)) {
      return;
    }

    this.getCommentBox((comment) => {
      this.loader.show();

      if (comment && comment.trim().length > 0) {
        candidate.profileEditComment =
          this.configureComment(comment, ImmigrationCommentTypes.Approve);
      }
      this.loader.show();
      this.employeeApi.approveEmployeeProfile(candidate).pipe(finalize(() => {
        this.loader.clear();
      })).subscribe(resp => {
        this.toaster.success('Profile approved!');
        this.close();
      });
    }, true, "");
  }
  get canAccDec() {
    return this.authService.ActiveUser.features.includes('VisaApprover');
  }

  close() {
    this._location.back();
  }

  getCommentBox(onSub: (data) => void, isEnabled, message) {
    const control = this.dialog.open(ArCommentComponent);
    control.componentInstance.isApprove = isEnabled;
    if (message.length > 0) {
      control.componentInstance.message = message;
    }
    control.result.then(closeParam => {
      if (!isEnabled && nullSafe<number>(() => closeParam.Comment.trim().length, -1) <= 0) {
        return;
      }
      if (onSub) {
        onSub(closeParam.Comment);
      }
    }
      , dismiss => {

      });
  }

  sendMail(mail) {
    this.loader.show();
    this.emailAPI.sendEmployeeMMail(mail).pipe(finalize(() => {
      this.loader.clear();
    }))
      .subscribe((resp) => {
      }, (err) => {
        this.toast.error('Error occured while sending email.');
        this.loader.clear();
      });
  }

  openMail() {
    this.dialogServ
      .showConfirmationBox(
        "Send profile update reminder",
        "This will trigger an email notification to employee asking to update the profile. Do you want to continue?",
        () => {
          this.loader.show();
          this.emailAPI.sendEmpProfileUpdateReminder(this.model.employeeId).pipe(finalize(() => {
            this.loader.clear();
          })).subscribe(resp => {
            this.toast.success('Reminder sent successfuly!');
          });
        });
    // this.dialogServ.loadGenMail(this.model ,(mail) => this.sendMail(mail));
  }

  get employeeInfo() {
    return getModifiedNameWithPhone(this.model);
  }

  showHistory() {
    this.dialogServ.showUserProfileHistory(this.model.gpn, this.model.gui);
  }
  showTab(tab: number) {
    if (tab == 1 && this.formArray.dirty && !this.immUserProfileView) {
      this.toast.warning("Please click save and continue")
      this.activeTabIdx = 0
      return;
    }
    if (tab > 1 || tab < 0) {
      return;
    }
    this.activeTabIdx = tab;
  }

  validateDependents(candidate) {
    let childrenDetails = candidate.profile.childrenDetails ? JSON.parse(candidate.profile.childrenDetails).formData : null;
    let spouseDetails = candidate.profile.spouseDetails ? JSON.parse(candidate.profile.spouseDetails).formData : null;
    let missingDependents = 0;

    const fields = ['firstName', 'lastName', 'nationality', 'passportNumber', 'passportExpiryDate',
      'dateOfBirth', 'placeOfBirth', 'gender', 'dependentCurrentLocation',
      'visaStatus'];

    if (childrenDetails && childrenDetails.length > 0) {

      for (let i = 0; i < childrenDetails.length; i++) {
        fields.forEach(f => {
          //console.log(f + '=>' + childrenDetails[i]['' + f + '']);
          if (!childrenDetails[i]['' + f + '']) {
            missingDependents = 1;
          }
          else if (childrenDetails[i]['' + f + ''] != null && typeof childrenDetails[i]['' + f + ''] === 'object' && !childrenDetails[i]['' + f + ''].id) {
            missingDependents = 1;
          }         
        });
      }
    }

    if (spouseDetails && spouseDetails.length > 0) {

      fields.push('isYourSpouseCurrentlyWorkingForEY');

      for (let i = 0; i < spouseDetails.length; i++) {
        fields.forEach(f => {
          //console.log(f + '=>' + spouseDetails[i]['' + f + '']);
          if (!spouseDetails[i]['' + f + '']) {
            missingDependents = 1;
          }
          else if (spouseDetails[i]['' + f + ''] != null && typeof spouseDetails[i]['' + f + ''] === 'object' && !spouseDetails[i]['' + f + ''].id) {            
            // console.log(spouseDetails[i]['' + f + '']);
            // console.log(JSON.stringify(spouseDetails[i]['' + f + '']));
            missingDependents = 1;
          }
        });

      }
    }
    return missingDependents;
  }

  validateEmployeeProfile(candidate) {

    if (!this.validations.validateSubmit(this.formArray)) {
      this.activeTabIdx = 0;
      return false;
    }

    if (this.validateDependents(candidate) == 1) {
      this.toast.warning("Please enter mandatory Dependent details");
      return false;
    }

    const ValidateDocuuments = this.common.validEmployeeDocs(this.uploadedFiles, this.validDocuments, this.dependentDocs)

    if (!ValidateDocuuments.valid) {
      this.dialogServ.showPopUpMessage(ValidateDocuuments.message, () => { }, "Missing documents");
      //this.toast.warning(ValidateDocuuments.message);
      return false;
    }

    return true;
  }
  confirmExpiryUpdate(onConfirm: () => void, onCancel?: () => void): void {
    
    const validatedMessage = this.common.validateExpiryDate(this.model, this.masterData,this.formArray); 
    if(validatedMessage.id > 0 && validatedMessage.message.length > 0 && validatedMessage.isCurrent){
      this.dialogServ.showPopUpMessage( `The expiry date you've entered is earlier than the current date. Please update <br>` + validatedMessage.message
        ,null,
       "Update Expiry Date"
        );
    }   
    else if (validatedMessage.id > 0 && validatedMessage.message.length > 0) {
      this.dialogServ.showConfirmationBox(
        'Confirm Expiry update',
        `<div>The expiry date you've entered is earlier than the previously submitted date. Do you wish to submit with this update?<br/><div>` + validatedMessage.message,
        () => { onConfirm();},
        () => {
          if (onCancel) 
          { onCancel();}
        },
        true
      );
    } else {
      onConfirm(); // No confirmation needed
    }
  }
  getMasterData(){
    this.employeeApi.getEmployeeProfilesDetails(this.model.gpn, this.model.gui, "NA")
    .pipe(finalize(() => {
    })).subscribe(resp => {
       this.masterData = resp;
    });
  }
  GetActiveTabIndex($event){
    this.activeTabIdx = $event;
   }

private isPassportExpiryChanged(): boolean {
  const oldDate = this.masterData?.passportExpiryDate;
  const newDate = this.model?.passportExpiryDate;
  if (!oldDate) {
    return false;
  }
return new Date(oldDate).getTime() !== new Date(newDate || oldDate).getTime();
}

showPassportTransferPopup(countryCode: string){
  this.dialogServ.showCommentConfirmationBox(
    'Visa Transfer',
    'Would you like to submit a request to transfer your residency visa to your new passport?',
    () =>{
      // storing gpn and gui in session storage to be used in pre-filling the visa transfer request form
        sessionStorage.setItem('immPrefill', JSON.stringify({
          gpn: this.model.gpn,
          gui: this.model.gui
        }));
        if ([CountryTypesValues.BHR, CountryTypesValues.OMAN, CountryTypesValues.QAT].includes(countryCode as CountryTypesValues)){
        window.open(`/immigration/visa/${countryCode}/${countryCode}-TransferOfResidencyPermitToNewPassport`, '_blank');
        }
        else if(countryCode === CountryTypesValues.KWT) {
          window.open(`/immigration/visa/${countryCode}/${countryCode}-TransferOfResidencyToNewPassport`, '_blank');
        }
    else if(countryCode === CountryTypesValues.SaudiArabia){
    const url = this.router.serializeUrl(
    this.router.createUrlTree([`/immigration/visa/${countryCode}/PassportInfoUpdate`])
    );
    window.open(url, '_blank');
}
        else if(countryCode === CountryTypesValues.UAE){
          window.open(`/immigration/visa/${countryCode}/${countryCode}-TransferResidency`, '_blank');        
        }
        else{
          this.toaster.error('Visa transfer request is not available for your country office.');
        }
    }
  )
  }

}
